import { render, staticRenderFns } from "./balanceView.vue?vue&type=template&id=58be9d01&"
import script from "./balanceView.vue?vue&type=script&lang=js&"
export * from "./balanceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports